import React from 'react';
import classnames from 'classnames';
import * as styles from './contactsContainer.module.scss';
import { CONTACT_EMAIL, CONTACT_PHONE } from '@/mocks/contacts';

const SocialsContainer = ({ support }) => {
  return (
    <div className={classnames(styles.contacts)}>
      <p className={classnames(styles.textWrap, 'cr-reg')}>
        <span className={classnames(styles.title)}>{support.title}</span> &#160;
        <span className={classnames(styles.subtitle)}>{support.subtitle}</span>
      </p>

      <ul className={classnames(styles.list)}>
        <li>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className={classnames('cr-main cr-link cr-subheader-3')}
            target="_blank"
            rel="noreferrer"
          >
            {CONTACT_EMAIL}
          </a>
        </li>
        <li>
          <a
            href={`tel:${CONTACT_PHONE}`}
            className={classnames('cr-link cr-subheader-3')}
            target="_blank"
            rel="noreferrer"
          >
            {CONTACT_PHONE}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialsContainer;
